export const getClientLogicalGroupIndex = (secondObjectIndex: number) => {
  const humanSecondObjectIndex = secondObjectIndex + 1;
  const objectsCountWithoutExcludedTags = humanSecondObjectIndex / 2;
  const logicalGroupIndex = objectsCountWithoutExcludedTags - 1;

  return logicalGroupIndex;
};
